import {createReducer, on} from '@ngrx/store';
import {
  ClearState,
  FetchMetricsDataFailure,
  FetchMetricsDataRequest,
  FetchMetricsDataSuccess,
  FetchMetricsOptionsFailure,
  FetchMetricsOptionsRequest,
  FetchMetricsOptionsSuccess,
} from './metrics.actions';
import {MetricOptionModel} from '../../../../models/metric-option.model';

// State for this feature (User)
export interface MetricsState {
  metricsData: {};
  metricsOptions: {
    loading: boolean,
    data: MetricOptionModel[],
  }
}

const initialState: MetricsState = {
  metricsData: {},
  metricsOptions: {
    loading: false,
    data: [],
  }
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, () => initialState),

  // FETCH Metrics List
  on(FetchMetricsOptionsRequest, (state) => ({
    ...state,
    metricsOptions: {
      ...initialState.metricsOptions,
      loading: true,
    }
  })),
  on(FetchMetricsOptionsSuccess, (state, props) => ({
    ...state,
    metricsOptions: {
      data: props.metricsOptions,
      loading: false,
    }
  })),
  on(FetchMetricsOptionsFailure, (state) => ({
    ...state,
    metricsOptions: {
      ...initialState.metricsOptions,
      loading: false,
    }
  })),

  // FETCH METRICS DATA
  on(FetchMetricsDataRequest, (state, props) => ({
    ...state,
    metricsData: {
      ...state.metricsData,
      [props.payload.code]: {
        ...state.metricsData[props.payload.code],
        loading: true,
      },
    }
  })),
  on(FetchMetricsDataSuccess, (state, props) => ({
    ...state,
    metricsData: {
      ...state.metricsData,
      [props.code]: {
        loading: false,
        data: props.data,
      },
    }
  })),
  on(FetchMetricsDataFailure, (state, props) => ({
    ...state,
    metricsData: {
      ...state.metricsData,
      [props.payload.code]: {
        ...state.metricsData[props.payload.code],
        loading: false,
      },
    }
  })),
);
